/* Package JSON Import will be here */
import React from "react";
import { connect } from "react-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { appRoutesConst } from "app/navigation";
import Constants from "../../utilities/appConstants";
/* Project Import will be here */

class HomeContainer extends React.Component {
  /* Get the main section header adjustment css class */
  getAdjustableCss = () => {
    const pathName = this.props.router.location.pathname;
    const pixelCount = (pathName.includes(appRoutesConst.productList) ||
    pathName.includes(Constants.PATH_INCLUDE_PRODUCTS) ||
    pathName === appRoutesConst.salesReturn ||
    pathName.includes(Constants.PATH_INCLUDE_SALES_RETURN_PRODUCTS)) ? "0px" : "30px";

    return {
      paddingTop: pixelCount
    };
  }
  render() {
    return (
      <React.Fragment>
        <section className="main-section" style={this.getAdjustableCss()}>{this.props.children}</section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    router: state.router
  };
};

export default connect(mapStateToProps, null)(HomeContainer);